import * as XLSX from "xlsx";

// Export a simple sheet (header row + data rows) as a real .xlsx file.
export function exportXlsx(headers, rows, filename) {
  exportXlsxSheets([{ name: "Sheet1", headers, rows }], filename);
}

// Several sheets in one workbook. JS Date cells are kept as real Excel dates shown dd/mm/yy; `formats` = {columnIndex: numberFormat}.
// Columns whose header names a weight ("(kg)", "Wt", "Weight") default to 2 decimals; width / thickness / CR / dia columns to DIM_FMT.
const KG_HDR = /\(kgs?\)|\bkgs?\b|weight|\bwt\b/i;
const DIM_HDR = /width|thickness|\bthk\b|\bt1\b|\bt2\b|\bcr\b|\bdia\b/i;
export function exportXlsxSheets(sheets, filename) {
  const wb = XLSX.utils.book_new();
  sheets.forEach(({ name, headers, rows, formats }) => {
    const ws = XLSX.utils.aoa_to_sheet([headers, ...rows], { cellDates: true });
    const auto = Object.fromEntries((headers || []).map((h, i) => [i, KG_HDR.test(String(h)) ? KG_FMT : DIM_HDR.test(String(h)) ? DIM_FMT : null]).filter(([, f]) => f));
    Object.keys(ws).forEach((addr) => {
      if (addr[0] === "!") return;
      const c = ws[addr];
      if (c.t === "d") c.z = "dd/mm/yy";
      else if (c.t === "n") { const col = XLSX.utils.decode_cell(addr); const f = col.r > 0 ? (formats && formats[col.c]) || auto[col.c] : null; if (f) c.z = f; }
    });
    XLSX.utils.book_append_sheet(wb, ws, String(name).slice(0, 31));
  });
  const name = String(filename || "export").replace(/\.(csv|xlsx?)$/i, "") + ".xlsx";
  XLSX.writeFile(wb, name, { cellDates: true });
}

export const xlsxDate = (iso) => (iso ? new Date(`${String(iso).slice(0, 10)}T00:00:00`) : "");
export const DIM_FMT = "0.00##";
export const KG_FMT = "#,##0.00";
